import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Select,
  Row,
  Col,
  Space,
  Typography,
  Spin,
  message,
  Divider,
} from "antd";

import {
  FilePdfOutlined,
  ReloadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";

import Swal from "sweetalert2";

import api from "../../api/api";
import { useAcademicYear } from "../../AcademicYearContext";

import ScreenGradeSheet from "./ScreenGradeSheet";
import ClassReportPDF from "../../SchoolDashApp/ReportCard/ClassReportPDF";
import { pdf } from "@react-pdf/renderer";
import { ClassReportDocument } from "../../SchoolDashApp/ReportCard/ClassReportPDF";


const { Title } = Typography;


const PeriodReport = () => {


  const {
    selectedYear: activeAcademicYear,
    loading: yearLoading,
  } = useAcademicYear();



  const [gradeClasses,setGradeClasses] = useState([]);
  const [students,setStudents] = useState([]);
  const [periods,setPeriods] = useState([]);
  const [loadingStudentDownload, setLoadingStudentDownload] = useState(false);



  const [
    selectedGradeClass,
    setSelectedGradeClass
  ] = useState(null);



  const [
    selectedStudent,
    setSelectedStudent
  ] = useState(null);



  const [
    selectedPeriod,
    setSelectedPeriod
  ] = useState(null);



  const [
    downloadGradeClass,
    setDownloadGradeClass
  ] = useState(null);



  const [
    downloadPeriod,
    setDownloadPeriod
  ] = useState(null);



  const [
    gradeSheet,
    setGradeSheet
  ] = useState(null);



  // const [
  //   classReports,
  //   setClassReports
  // ] = useState(null);



  const [
    loading,
    setLoading
  ] = useState(false);



  const [
    loadingClassDownload,
    setLoadingClassDownload
  ] = useState(false);





  /*
    Load Grade Classes
  */

  useEffect(()=>{


    api
    .get("/api/users/grade-classes/")
    .then(res=>{

      setGradeClasses(res.data);

    })
    .catch(()=>{

      setGradeClasses([]);

    });



  },[]);






  /*
    Load Periods
  */

  useEffect(()=>{


    api
    .get("/api/users/periods/")
    .then(res=>{

      setPeriods(res.data);

    })
    .catch(()=>{

      setPeriods([]);

    });



  },[]);









  /*
     Load Students Based On Grade Class + Academic Year
  */


  useEffect(()=>{


    if(
      selectedGradeClass &&
      activeAcademicYear
    ){


      api
      .get(
        `/students-by-grade-class/?grade_class=${selectedGradeClass.id}&academic_year=${activeAcademicYear.id}`
      )
      .then(res=>{

        setStudents(res.data);

      })
      .catch(()=>{

        setStudents([]);

      });



      setSelectedStudent(null);


    }
    else{

      setStudents([]);

    }


  },[
    selectedGradeClass,
    activeAcademicYear
  ]);









  /*
      Generate Single Student Grade Sheet
  */


  const handleDownloadStudentGradeSheet = async () => {
  if (!gradeSheet) {
    Swal.fire({
      icon: "warning",
      title: "Grade Sheet Required",
      text: "Please generate a student grade sheet first.",
      confirmButtonText: "OK",
      confirmButtonColor: "#7f1d1d",
    });

    return;
  }

  if (!selectedGradeClass || !selectedPeriod) {
    Swal.fire({
      icon: "warning",
      title: "Selection Required",
      text: "Please select a grade class and period.",
      confirmButtonText: "OK",
      confirmButtonColor: "#7f1d1d",
    });

    return;
  }

  try {
    setLoadingStudentDownload(true);

    Swal.fire({
      title: "Preparing Grade Sheet",
      text: "Please wait while the student grade sheet is being prepared...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const blob = await pdf(
      <ClassReportDocument
        reports={[gradeSheet]}
        gradeClass={selectedGradeClass}
        period={selectedPeriod}
      />
    ).toBlob();

    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = url;

    link.download =
      `${gradeSheet.student_name || selectedStudent?.full_name || "Student"}_Grade_Sheet_${selectedPeriod.name}.pdf`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    setTimeout(() => {
      URL.revokeObjectURL(url);
    }, 1000);

    Swal.close();

    await Swal.fire({
      icon: "success",
      title: "Download Complete",
      text: `The grade sheet for ${gradeSheet.student_name || selectedStudent?.full_name} has been downloaded successfully.`,
      confirmButtonText: "OK",
      confirmButtonColor: "#7f1d1d",
    });
  } catch (error) {
    console.error(
      "Student grade sheet download error:",
      error
    );

    Swal.close();

    Swal.fire({
      icon: "error",
      title: "Download Failed",
      text:
        error.response?.data?.error ||
        "The student grade sheet could not be generated or downloaded. Please try again.",
      confirmButtonText: "OK",
      confirmButtonColor: "#7f1d1d",
    });
  } finally {
    setLoadingStudentDownload(false);
  }
};


  const handleGenerate = async()=>{


    if(
      !selectedGradeClass ||
      !selectedStudent ||
      !selectedPeriod
    ){

      message.error(
        "Please select grade class, student and period"
      );

      return;

    }



    if(!activeAcademicYear){


      message.error(
        "Academic year not loaded"
      );

      return;

    }



    try{


      setLoading(true);



      const response =
      await api.post(
        "/api/users/student-averages/",
        {


          grade_class:
          selectedGradeClass.id,


          student:
          selectedStudent.id,


          period:
          selectedPeriod.id,


          academic_year:
          activeAcademicYear.id

        }
      );



      setGradeSheet(response.data);



      message.success(
        "Grade sheet generated"
      );


    }
    catch(error){


      message.error(
        error.response?.data?.error ||
        "Failed to generate grade sheet"
      );


    }
    finally{


      setLoading(false);


    }


  };
const handleDownloadClassGrades =
  async()=>{

    if(
      !downloadGradeClass ||
      !downloadPeriod
    ){

      Swal.fire({

        icon:"warning",

        title:"Selection Required",

        text:"Please select a grade class and period before downloading.",

        confirmButtonText:"OK",

        confirmButtonColor:"#7f1d1d"

      });

      return;

    }



    if(!activeAcademicYear){

      Swal.fire({

        icon:"error",

        title:"Academic Year Unavailable",

        text:"The active academic year has not loaded yet.",

        confirmButtonText:"OK",

        confirmButtonColor:"#7f1d1d"

      });

      return;

    }



    try{


      setLoadingClassDownload(true);



      Swal.fire({

        title:"Preparing Grade Reports",

        text:"Please wait while the class grade reports are being generated...",

        allowOutsideClick:false,

        allowEscapeKey:false,

        showConfirmButton:false,

        didOpen:()=>{

          Swal.showLoading();

        }

      });



      const response =
      await api.post(

        "/api/users/student-averages/class-report/",

        {

          grade_class:
          downloadGradeClass.id,


          period:
          downloadPeriod.id,


          academic_year:
          activeAcademicYear.id

        }

      );



      if(

        !response.data ||

        response.data.length === 0

      ){

        Swal.close();



        Swal.fire({

          icon:"info",

          title:"No Reports Found",

          text:"There are no grade reports available for the selected class and period.",

          confirmButtonText:"OK",

          confirmButtonColor:"#7f1d1d"

        });

        return;

      }



      const blob =

      await pdf(

        <ClassReportDocument

          reports={response.data}

          gradeClass={downloadGradeClass}

          period={downloadPeriod}

        />

      ).toBlob();



      const url =

      URL.createObjectURL(blob);



      const link =

      document.createElement("a");



      link.href = url;



      link.download =

      `Class_${downloadGradeClass.name}_${downloadPeriod.name}.pdf`;



      document.body.appendChild(link);



      link.click();



      document.body.removeChild(link);



      setTimeout(()=>{

        URL.revokeObjectURL(url);

      },1000);



      Swal.close();



      await Swal.fire({

        icon:"success",

        title:"Download Complete",

        text:

        `The grade reports for ${downloadGradeClass.name} - ${downloadPeriod.name} have been downloaded successfully.`,

        confirmButtonText:"OK",

        confirmButtonColor:"#7f1d1d"

      });


    }

    catch(error){


      console.error(

        "Class grade download error:",

        error

      );



      Swal.close();



      Swal.fire({

        icon:"error",

        title:"Download Failed",

        text:

        error.response?.data?.error ||

        "The class grade reports could not be generated or downloaded. Please try again.",

        confirmButtonText:"OK",

        confirmButtonColor:"#7f1d1d"

      });


    }

    finally{


      setLoadingClassDownload(false);


    }


  };
const handleDelete=()=>{


    if(!gradeSheet)
      return;



    Swal.fire({

      title:"Delete Grade Sheet?",

      text:"This action cannot be undone",

      icon:"warning",

      showCancelButton:true,

      confirmButtonText:"Delete"


    })
    .then(async(result)=>{


      if(result.isConfirmed){


        try{


          await api.delete(
            `/api/users/student-averages/${gradeSheet.id}/`
          );


          setGradeSheet(null);


          Swal.fire(
            "Deleted",
            "Grade sheet removed",
            "success"
          );


        }
        catch{


          Swal.fire(
            "Error",
            "Delete failed",
            "error"
          );


        }


      }


    });


  };









  return (

<Card>


<Title level={3}>
Generate Student Grade Sheet
</Title>



{
yearLoading ?

<Spin/>

:

<>

<Row gutter={[16,16]}>


<Col xs={24} md={8}>

<Select

style={{
width:"100%"
}}

placeholder="Select Grade Class"

value={
selectedGradeClass?.id
}

options={
gradeClasses.map(item=>({

label:item.name,

value:item.id,

data:item

}))
}

onChange={(value,option)=>{

setSelectedGradeClass(
option.data
);

}}


/>


</Col>





<Col xs={24} md={8}>


<Select

style={{
width:"100%"
}}

placeholder="Select Student"

disabled={
!selectedGradeClass
}


value={
selectedStudent?.id
}


options={
students.map(item=>({

label:item.full_name,

value:item.id,

data:item

}))
}



onChange={(value,option)=>{

setSelectedStudent(
option.data
);

}}


/>


</Col>






<Col xs={24} md={8}>


<Select

style={{
width:"100%"
}}

placeholder="Select Period"


value={
selectedPeriod?.id
}


options={
periods.map(item=>({

label:item.name,

value:item.id,

data:item

}))
}



onChange={(value,option)=>{

setSelectedPeriod(
option.data
);

}}


/>


</Col>


</Row>





<Divider/>




<Button

type="primary"

loading={loading}

onClick={handleGenerate}

>

Generate Grade Sheet

</Button>




{
gradeSheet &&

<>

<ScreenGradeSheet
data={gradeSheet}
/>



<Space>
  <Button
    danger
    icon={<DownloadOutlined />}
    loading={loadingStudentDownload}
    onClick={handleDownloadStudentGradeSheet}
  >
    Download Grade Sheet
  </Button>
</Space>
</>
}

<Divider/>

<Title level={3}>
Download Class Grades
</Title>
<Row gutter={[16,16]}>
<Col xs={24} md={12}>
<Select

style={{
width:"100%"
}}

placeholder="Select Grade Class"


options={
gradeClasses.map(item=>({

label:item.name,

value:item.id,

data:item

}))
}


onChange={(value,option)=>{

setDownloadGradeClass(
option.data
);

}}


/>


</Col>





<Col xs={24} md={12}>


<Select

style={{
width:"100%"
}}

placeholder="Select Period"


options={
periods.map(item=>({

label:item.name,

value:item.id,

data:item

}))
}


onChange={(value,option)=>{

setDownloadPeriod(
option.data
);

}}


/>


</Col>



</Row>





<Button

type="primary"

icon={<FilePdfOutlined/>}

loading={loadingClassDownload}

onClick={handleDownloadClassGrades}

style={{
marginTop:20
}}

>

Download Class Grades

</Button>





{/* {
classReports &&

<ClassReportPDF
        key={`${downloadGradeClass?.id}-${downloadPeriod?.id}`}
        reports={classReports}
        gradeClass={downloadGradeClass}
        period={downloadPeriod}
        onDownloaded={()=>{
            setClassReports(null);
        }}
    />

} */}



</>

}


</Card>


  );


};



export default PeriodReport;

